"use client";

import { PostHogAuthIntegration } from "@/dashboard/analytics/PostHogAuthIntegration";
import { PostHogProvider } from "@/dashboard/analytics/PostHogProvider";
import AuthProvider from "@/dashboard/contexts/auth-context";
import { BannerProvider } from "@/dashboard/contexts/banner-context";
import FeatureProvider from "@/dashboard/contexts/feature-context";
import QueryProvider from "@/dashboard/contexts/query-client-context";
import { WSClientProvider } from "@/dashboard/contexts/ws-client-context";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider>
      <QueryProvider>
        <AuthProvider>
          <PostHogAuthIntegration />
          <WSClientProvider>
            <FeatureProvider>
              <BannerProvider>{children}</BannerProvider>
            </FeatureProvider>
          </WSClientProvider>
        </AuthProvider>
      </QueryProvider>
    </PostHogProvider>
  );
}
